import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CardSharedComponent } from './card.component';
import { CardPlainSharedComponent } from './card-plain/card-plain.component';

import { IconSharedModule } from './../../atoms/icon/icon.module';
import { ListSharedModule } from './../../atoms/list/list.module';
import { BadgeSharedModule } from './../../atoms/badge/badge.module';
import { ImageSharedModule } from './../../atoms/image/image.module';
import { IconNavSharedModule } from './../../molecules/icon.nav/icon.nav.module';
import { AddToCalendarSharedModule } from './../../molecules/add.to.calendar/add.to.calendar.module';

import { ArrayService } from './../../../shared/service/array/array.service';

@NgModule({
    declarations: [
        CardSharedComponent,
        CardPlainSharedComponent
    ],
    imports: [
        CommonModule,
        ListSharedModule,
        ImageSharedModule,
        BadgeSharedModule,
        IconNavSharedModule,
        AddToCalendarSharedModule,
        RouterModule.forChild([]),
        IconSharedModule
    ],
    exports: [
        CardSharedComponent,
        CardPlainSharedComponent
    ],
    providers: [
        ArrayService
    ]
})

export class CardSharedModule {}
